import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import Cookies from "js-cookie";

const BaseURL = process.env.REACT_APP_API_URL;
const token = Cookies.get("authToken");

const DataBase = Cookies.get("Database");
const ProjectIDs = localStorage.getItem("projectId");

export const AcGroupList = createAsyncThunk("FAS/AcGroupList", async (data) => {
  try {
    const response = await axios.post(
      `${BaseURL}/FAS/AcGroupList`,
      {
        FirmIDs: data.Firm,
        DataBase: DataBase,
        ProjectIDs: ProjectIDs,
        AcYearIDs: data.Year,
      },
      {
        headers: {
          token: token,
          "Content-Type": "application/json",
          "Cache-Control": "no-cache",
        },
      },
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response ? error.response.data : "Network Error");
  }
});

export const AcList = createAsyncThunk("FAS/AcList", async (data) => {
  try {
    const response = await axios.post(
      `${BaseURL}/FAS/AcList`,
      {
        FirmIDs: data.Firm,
        DataBase: DataBase,
        ProjectIDs: ProjectIDs,
        AcYearIDs: data.Year,
        AcGroupIDs: data.selectedIds ? data.selectedIds : "",
      },
      {
        headers: {
          token: token,
          "Content-Type": "application/json",
          "Cache-Control": "no-cache",
        },
      },
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response ? error.response.data : "Network Error");
  }
});

export const ReceivablePayable = createAsyncThunk(
  "FAS/ReceivablePayable",
  async (data) => {
    console.log(data);

    try {
      const response = await axios.post(
        `${BaseURL}/FAS/ReceivablePayable`,
        {
          FirmIDs: data.Firm,
          DataBase: DataBase,
          ProjectIDs: ProjectIDs,
          AcYearIDs: data.AcYearIDs ? data.AcYearIDs : "",
          GroupMstIDs: data.selectedIds ? data.selectedIds : "",
          StartDate: data.startDate,
          EndDtate: data.endDate,
        },
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
        },
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  },
);

export const RecPayMonth = createAsyncThunk("RecPay/RecMonth", async (data) => {
  try {
    const response = await axios.post(
      `${BaseURL}/RecPay/RecMonth`,
      {
        FirmIDs: data.Firm,
        DataBase: DataBase,
        ProjectIDs: ProjectIDs,
        AcYearIDs: data.Year,
        ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
        StartDate: data.startDate ? data.startDate : "",
        EndDate: data.endDate ? data.endDate : "",
      },
      {
        headers: {
          token: token,
          "Content-Type": "application/json",
          "Cache-Control": "no-cache",
        },
      },
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response ? error.response.data : "Network Error");
  }
});

export const RecAging = createAsyncThunk("RecPay/RecAging", async (data) => {
  try {
    const response = await axios.post(
      `${BaseURL}/RecPay/RecAging`,
      {
        FirmIDs: data.Firm,
        DataBase: DataBase,
        ProjectIDs: ProjectIDs,
        AcYearIDs: data.Year,
        ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
        StartDate: data.startDate ? data.startDate : "",
        EndDate: data.endDate ? data.endDate : "",
        SlotSize: data.SlotSize ? data.SlotSize : "",
      },
      {
        headers: {
          token: token,
          "Content-Type": "application/json",
          "Cache-Control": "no-cache",
        },
      },
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response ? error.response.data : "Network Error");
  }
});

export const RecAgingDtl = createAsyncThunk(
  "RecPay/RecAgingDtl",
  async (data) => {
    try {
      const response = await axios.post(
        `${BaseURL}/RecPay/RecAgingDtl`,
        {
          FirmIDs: data.Firm,
          DataBase: DataBase,
          ProjectIDs: ProjectIDs,
          AcYearIDs: data.Year,
          ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
          StartDate: data.startDate ? data.startDate : "",
          EndDate: data.endDate ? data.endDate : "",
          SlotSize: data.SlotSize ? data.SlotSize : "",
          AcIDs: data.selectedId1 ? data.selectedId1 : "",
        },
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
        },
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  },
);

export const RecOutstanding = createAsyncThunk(
  "RecPay/RecOutstanding",
  async (data) => {
    try {
      const response = await axios.post(
        `${BaseURL}/RecPay/RecOutstanding`,
        {
          FirmIDs: data.Firm,
          DataBase: DataBase,
          ProjectIDs: ProjectIDs,

          ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
          StartDate: data.startDate ? data.startDate : "",
          EndDate: data.endDate ? data.endDate : "",
        },
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
        },
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  },
);

export const RecReceiptMonth = createAsyncThunk(
  "RecPay/RecReceiptMonth",
  async (data) => {
    try {
      const response = await axios.post(
        `${BaseURL}/RecPay/RecReceiptMonth`,
        {
          FirmIDs: data.Firm,
          AcYearIDs: data.Year,
          DataBase: DataBase,
          ProjectIDs: ProjectIDs,
          ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
        },
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
        },
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  },
);

export const RecAdjDtl = createAsyncThunk("RecPay/RecAdjDtl", async (data) => {
  try {
    const response = await axios.post(
      `${BaseURL}/RecPay/RecAdjDtl`,
      {
        FirmIDs: data.Firm,
        DataBase: DataBase,
        ProjectIDs: ProjectIDs,
        ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
        AcIDs: data.selectedId1 ? data.selectedId1 : "",
        StartDate: data.startDate ? data.startDate : "",
        EndDate: data.endDate ? data.endDate : "",
      },
      {
        headers: {
          token: token,
          "Content-Type": "application/json",
          "Cache-Control": "no-cache",
        },
      },
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response ? error.response.data : "Network Error");
  }
});

export const RecReceiptAc = createAsyncThunk(
  "RecPay/RecReceiptAc",
  async (data) => {
    try {
      const response = await axios.post(
        `${BaseURL}/RecPay/RecReceiptAc`,
        {
          FirmIDs: data.Firm,
          DataBase: DataBase,
          ProjectIDs: ProjectIDs,
          AcYearIDs: data.Year,
          ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
          AcIDs: data.selectedId1 ? data.selectedId1 : "",
          StartDate: data.startDate ? data.startDate : "",
          EndDate: data.endDate ? data.endDate : "",
        },
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
        },
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  },
);
export const RecReceiptAcYear = createAsyncThunk(
  "RecPay/RecReceiptAcYear",
  async (data) => {
    try {
      const response = await axios.post(
        `${BaseURL}/RecPay/RecReceiptAcYear`,
        {
          FirmIDs: data.Firm,
          DataBase: DataBase,
          ProjectIDs: ProjectIDs,
          AcYearIDs: data.Year,
          ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",
          AcIDs: data.selectedId1 ? data.selectedId1 : "",
          StartDate: data.startDate ? data.startDate : "",
          EndDate: data.endDate ? data.endDate : "",
        },
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
        },
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  },
);

export const PayMonth = createAsyncThunk("RecPay/PayMonth", async (data) => {
  try {
    const response = await axios.post(
      `${BaseURL}/RecPay/PayMonth`,
      {
        FirmIDs: data.Firm,
        DataBase: DataBase,
        ProjectIDs: ProjectIDs,
        AcYearIDs: data.Year,
        GroupMstIDs: data.selectedIds ? data.selectedIds : "",
        StartDate: data.startDate ? data.startDate : "",
        EndDate: data.endDate ? data.endDate : "",
      },
      {
        headers: {
          token: token,
          "Content-Type": "application/json",
          "Cache-Control": "no-cache",
        },
      },
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response ? error.response.data : "Network Error");
  }
});

export const PayAging = createAsyncThunk("RecPay/PayAging", async (data) => {
  try {
    const response = await axios.post(
      `${BaseURL}/RecPay/PayAging`,
      {
        FirmIDs: data.Firm,
        DataBase: DataBase,
        ProjectIDs: ProjectIDs,
        AcYearIDs: data.Year,
        GroupMstIDs: data.selectedIds ? data.selectedIds : "",
        StartDate: data.startDate ? data.startDate : "",
        EndDate: data.endDate ? data.endDate : "",
        SlotSize: data.SlotSize ? data.SlotSize : "",
      },
      {
        headers: {
          token: token,
          "Content-Type": "application/json",
          "Cache-Control": "no-cache",
        },
      },
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response ? error.response.data : "Network Error");
  }
});

export const PayOutstanding = createAsyncThunk(
  "RecPay/PayOutstanding",
  async (data) => {
    try {
      const response = await axios.post(
        `${BaseURL}/RecPay/PayOutstanding`,
        {
          FirmIDs: data.Firm,
          DataBase: DataBase,
          ProjectIDs: ProjectIDs,
          AcYearIDs: data.Year,
          GroupMstIDs: data.selectedIds ? data.selectedIds : "",
          StartDate: data.startDate ? data.startDate : "",
          EndDate: data.endDate ? data.endDate : "",
        },
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
        },
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  },
);

export const PayAgingDtl = createAsyncThunk(
  "RecPay/PayAgingDtl",
  async (data) => {
    try {
      const response = await axios.post(
        `${BaseURL}/RecPay/PayAgingDtl`,
        {
          FirmIDs: data.Firm,
          DataBase: DataBase,
          ProjectIDs: ProjectIDs,
          AcYearIDs: data.Year,
          GroupMstIDs: data.selectedIds ? data.selectedIds : "",
          StartDate: data.startDate ? data.startDate : "",
          EndDate: data.endDate ? data.endDate : "",
          SlotSize: data.SlotSize ? data.SlotSize : "",
          AcIDs: data.selectedId1 ? data.selectedId1 : "",
        },
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
        },
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  },
);

export const PayReceiptMonth = createAsyncThunk(
  "RecPay/PayReceiptMonth",
  async (data) => {
    try {
      const response = await axios.post(
        `${BaseURL}/RecPay/PayReceiptMonth`,
        {
          FirmIDs: data.Firm,
          AcYearIDs: data.Year,
          DataBase: DataBase,
          ProjectIDs: ProjectIDs,
          GroupMstIDs: data.selectedIds ? data.selectedIds : "",
        },
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
        },
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  },
);

export const PayAdjDtl = createAsyncThunk("RecPay/PayAdjDtl", async (data) => {
  try {
    const response = await axios.post(
      `${BaseURL}/RecPay/PayAdjDtl`,
      {
        FirmIDs: data.Firm,
        DataBase: DataBase,
        ProjectIDs: ProjectIDs,
        GroupMstIDs: data.selectedIds ? data.selectedIds : "",
        AcIDs: data.selectedId1 ? data.selectedId1 : "",
        StartDate: data.startDate ? data.startDate : "",
        EndDate: data.endDate ? data.endDate : "",
      },
      {
        headers: {
          token: token,
          "Content-Type": "application/json",
          "Cache-Control": "no-cache",
        },
      },
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response ? error.response.data : "Network Error");
  }
});

export const ReceivablePaybleSlice = createSlice({
  name: "FAS",
  initialState: {
    Payable: null,
    AcGroupdata: null,
    RecPayMonthdata: null,
    RecAgingdata: null,
    RecAgingDtldata: null,
    PayMonthdata: null,
    PayAgingdata: null,
    PayOutstandingdata: null,
    RecOutstandingdata: null,
    PayAgingDtldata: null,
    RecReceiptMonthdata: null,
    PayReceiptMonthdata: null,
    RecAdjDtldata: null,
    PayAdjDtldata: null,
    RecReceiptAcdata: null,
    RecReceiptAcYeardata: null,
    AcName: null,
    status: "idle",
    error: null,
  },
  reducers: {
    RecAgingFun: (state) => {
      state.RecAgingdata = "no";
    },
    RecPayMonthFun: (state) => {
      state.RecPayMonthdata = "no";
    },
    RecAgingDtlFun: (state) => {
      state.RecAgingDtldata = "no";
    },
    RecOutstandingFun: (state) => {
      state.RecOutstandingdata = "no";
    },
    RecReceiptMonthFun: (state) => {
      state.RecReceiptMonthdata = "no";
    },
    RecAdjDtlFun: (state) => {
      state.PayAdjDtldata = "no";
    },
    RecReceiptAcYearFun: (state) => {
      state.RecReceiptAcYeardata = "no";
    },
    RecReceiptAcFun: (state) => {
      state.RecReceiptAcdata = "no";
    },
    RecAdjDtldataFun: (state) => {
      state.RecAdjDtldata = "no";
    },

    PayMonthFun: (state) => {
      state.PayMonthdata = "no";
    },
    PayAgingDtlFun: (state) => {
      state.PayAgingDtldata = "no";
    },
    PayAgingFun: (state) => {
      state.PayAgingdata = "no";
    },
    PayOutstandingFun: (state) => {
      state.PayOutstandingdata = "no";
    },
    PayReceiptMonthFun: (state) => {
      state.PayReceiptMonthdata = "no";
    },
    PayAdjDtlFun: (state) => {
      state.PayAdjDtldata = "no";
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(ReceivablePayable.pending, (state) => {
        state.status = "loading";
      })
      .addCase(ReceivablePayable.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.Payable = action.payload;
      })
      .addCase(ReceivablePayable.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(AcGroupList.pending, (state) => {
        state.status = "loading";
      })
      .addCase(AcGroupList.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.AcGroupdata = action.payload;
      })
      .addCase(AcGroupList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(AcList.pending, (state) => {
        state.status = "loading";
      })
      .addCase(AcList.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.AcName = action.payload;
      })
      .addCase(AcList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(RecPayMonth.pending, (state) => {
        state.status = "loading";
      })
      .addCase(RecPayMonth.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.RecPayMonthdata = action.payload;
      })
      .addCase(RecPayMonth.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(RecAging.pending, (state) => {
        state.status = "loading";
      })
      .addCase(RecAging.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.RecAgingdata = action.payload;
      })
      .addCase(RecAging.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(RecAgingDtl.pending, (state) => {
        state.status = "loading";
      })
      .addCase(RecAgingDtl.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.RecAgingDtldata = action.payload;
      })
      .addCase(RecAgingDtl.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(PayMonth.pending, (state) => {
        state.status = "loading";
      })
      .addCase(PayMonth.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.PayMonthdata = action.payload;
      })
      .addCase(PayMonth.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(PayAging.pending, (state) => {
        state.status = "loading";
      })
      .addCase(PayAging.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.PayAgingdata = action.payload;
      })
      .addCase(PayAging.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(PayOutstanding.pending, (state) => {
        state.status = "loading";
      })
      .addCase(PayOutstanding.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.PayOutstandingdata = action.payload;
      })
      .addCase(PayOutstanding.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(RecOutstanding.pending, (state) => {
        state.status = "loading";
      })
      .addCase(RecOutstanding.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.RecOutstandingdata = action.payload;
      })
      .addCase(RecOutstanding.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(PayAgingDtl.pending, (state) => {
        state.status = "loading";
      })
      .addCase(PayAgingDtl.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.PayAgingDtldata = action.payload;
      })
      .addCase(PayAgingDtl.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(RecReceiptMonth.pending, (state) => {
        state.status = "loading";
      })
      .addCase(RecReceiptMonth.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.RecReceiptMonthdata = action.payload;
      })
      .addCase(RecReceiptMonth.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(PayReceiptMonth.pending, (state) => {
        state.status = "loading";
      })
      .addCase(PayReceiptMonth.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.PayReceiptMonthdata = action.payload;
      })
      .addCase(PayReceiptMonth.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(RecAdjDtl.pending, (state) => {
        state.status = "loading";
      })
      .addCase(RecAdjDtl.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.RecAdjDtldata = action.payload;
      })
      .addCase(RecAdjDtl.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(PayAdjDtl.pending, (state) => {
        state.status = "loading";
      })
      .addCase(PayAdjDtl.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.PayAdjDtldata = action.payload;
      })
      .addCase(PayAdjDtl.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(RecReceiptAc.pending, (state) => {
        state.status = "loading";
      })
      .addCase(RecReceiptAc.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.RecReceiptAcdata = action.payload;
      })
      .addCase(RecReceiptAc.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(RecReceiptAcYear.pending, (state) => {
        state.status = "loading";
      })
      .addCase(RecReceiptAcYear.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.RecReceiptAcYeardata = action.payload;
      })
      .addCase(RecReceiptAcYear.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});
export const {
  RecReceiptMonthFun,
  RecOutstandingFun,
  RecAgingDtlFun,
  RecPayMonthFun,
  RecAgingFun,
  PayReceiptMonthFun,
  PayOutstandingFun,
  PayAgingFun,
  PayAgingDtlFun,
  PayMonthFun,
  RecReceiptAcFun,
  RecReceiptAcYearFun,
  RecAdjDtlFun,
  PayAdjDtlFun,
  RecAdjDtldataFun
} = ReceivablePaybleSlice.actions;
export default ReceivablePaybleSlice.reducer;
